import HeaderPhone from "components/HeaderPhone";
import CallButton from "components/CallButton";
import Header from "components/Header";

import ArrivalLoadingScreen from "./ArrivalLoadingScreen";

/** The whole page for any wait on the way into the quote flow: the flow's
 * cream background and header over the loading mark alone, so the chrome
 * never changes between the wait and the screens around it. The header
 * carries `headerPhone` when the screen knows which line to call, and the
 * quote pages' call button otherwise. */
export default function QuoteFlowLoadingPage({
  headerPhone,
}: {
  headerPhone?: { href: string; label: string };
}) {
  return (
    <div className="flex min-h-screen flex-col bg-[#FBF7EC]">
      <Header
        quoteFlow
        quoteFlowWidth="form"
        actions={
          headerPhone ? (
            <HeaderPhone line={headerPhone} />
          ) : (
            <CallButton variant="compact" />
          )
        }
      />
      <ArrivalLoadingScreen />
    </div>
  );
}
